import { HttpClient } from '@angular/common/http';
import {
	AfterViewInit,
	ChangeDetectorRef,
	Component,
	HostListener,
	Inject,
	Input,
	LOCALE_ID,
	OnInit,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
	NavigationEnd,
	NavigationExtras,
	Router,
	ActivatedRoute,
} from '@angular/router';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { AccountService } from 'src/app/pages/account/services/account.service';
import { FundraiserService } from 'src/app/pages/fundraiser/services/fundraiser.service';
import { CustomBrandingService } from 'src/app/pages/user/custom-branding/services/custom-branding.service';
import { DashboardService } from 'src/app/pages/user/dashboard/services/dashboard.service';
import { BankService } from 'src/app/pages/user/profile/services/bank.service';
import { ProfileService } from 'src/app/pages/user/profile/services/profile.service';
import { Tools } from 'src/utilities/tools';
import { JWT } from '../../models/jwt';
import { User } from '../../models/user';
import { SidenavService } from '../../services/sidenav.service';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { CustomDomainService } from '../../services/custom-domain.service';
import { environment } from 'src/environments/environment';
import { MatExpansionModule } from '@angular/material/expansion';
import { StartFundraiserButtonComponent } from '../../../shared/components/start-fundraiser-button/start-fundraiser-button.component';
import { MatDividerModule } from '@angular/material/divider';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatCardModule } from '@angular/material/card';
import { FundraiserForHeaderComponent } from './fundraiser-for/fundraiser-for-header.component';
import { SupportComponent } from '../footer/support/support.component';
import { FeaturesComponent } from '../footer/features/features.component';
import { ProductsComponent } from '../footer/products/products.component';
import { FundraiserForComponent } from '../footer/fundraiser-for/fundraiser-for.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { MatButtonModule } from '@angular/material/button';
import { NgIf, NgStyle, NgClass, NgTemplateOutlet } from '@angular/common';
import { FlexModule } from '@angular/flex-layout/flex';
import { MatToolbarModule } from '@angular/material/toolbar';

/************************************************
 *
 * This class takes care of header section
 *
 ***********************************************/

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: true,
    imports: [MatToolbarModule, FlexModule, NgIf, MatButtonModule, NgStyle, ExtendedModule, MatIconModule, MatMenuModule, NgClass, FundraiserForComponent, ProductsComponent, FeaturesComponent, SupportComponent, FundraiserForHeaderComponent, MatCardModule, MatTooltipModule, MatDividerModule, NgTemplateOutlet, StartFundraiserButtonComponent, MatExpansionModule]
})
export class HeaderComponent implements OnInit, AfterViewInit {
	private _unsubscribeAll: Subject<any> = new Subject<any>();
	/** *GLOBAL VARIABLES---------------------------------------- */
	@Input() showFundraiserHeader: boolean = false;
	@Input() showFeaturesHeader: boolean = false;
	@Input() showSupportHeader: boolean = false;
	logo: any;
	currentLang: string = '';
	isLoggedIn: boolean = false;
	isShowText: Boolean = false;
	isShowIcon: Boolean = false;
	user: any;
	profileImage: any;
	currentFundraiser: any;
	public currentLanguageCode: string = '';
	subject = new Subject<string>();
	userProfile: any;
	userImg: any;
	defaultImage: any;
	whydonatePlatformUrl = $localize`:@@header_crowfunding_label:crowdfunding-fundraising`;
	donationPluginUrl = $localize`:@@header_donate_plugin_url:donate-button-website`;
	// digitalPinBoxUrl = $localize`:@@header_digital_box_url:digital-collection-box`;
	isReceiver: boolean = false;
	defaultProfileImage: string =
		'https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/whydonate_user/w=40';
	_activatedRoute: any;
	_router: any;
	isPersonalFundraising: boolean = true;
	isOrganisation: boolean = false;
	activeItem: string = '';
	mobileActiveItem: string = '';
	sidenavActiveItem: string = 'menu';
	IMAGE_PREFIX =
		'https://whydonate.in/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/';
	IMAGE_POSTFIX = '/public';
	isCustomDomainActive: boolean = false;

	constructor(
		public accountService: AccountService,
		public router: Router,
		private _http: HttpClient,
		private _changeDetectorRef: ChangeDetectorRef,
		public fundraiserService: FundraiserService,
		private _profileService: ProfileService,
		private _customBrandingService: CustomBrandingService,
		public _dashboardService: DashboardService,
		public _dialog: MatDialog,
		public _bankService: BankService,
		public _sidenavService: SidenavService,
		@Inject(LOCALE_ID) public locale: string,
		_activatedRoute: ActivatedRoute,
		_router: Router,
		_notificationService: NotificationService,
		public customDomainService: CustomDomainService
	) {
		this._activatedRoute = _activatedRoute;
		this._router = _router;
	}

	@HostListener('window:resize', ['$event'])
	onResize(event: any) {
		var innerWidth = window.innerWidth;

		this.setLogo(innerWidth);
		this.setSideNavDefaults();
	}

	ngOnInit(): void {
		this.getActiveItem();
		this.setSideNavDefaults();
		this._customBrandingService
			.getIsReceived()
			.subscribe((receivedValue: boolean) => {
				this.isReceiver = receivedValue;
			});

		//SET DEFAULTIMAGE AND DEFAULT LOGO
		this.setLogo(window.innerWidth);
		this.getUrl().subscribe();
		this.getLoggedInInfo();

		/** *Fetch and check if custom branding exists */

		/** *Update the sidebar view with the latest profile */
		this._profileService.profileUpdate
			.pipe(takeUntil(this._unsubscribeAll)) // Unsubscribe
			.subscribe((profile: any) => {
				if (profile) {
					/** *Update the the profile image */
					this.userProfile = profile;
					this.profileImage = this.userProfile?.data?.image;
					this.user = localStorage.getItem('user');

					let user_val = new User(
						JSON.parse(this.user)?.id,
						new JWT(
							JSON.parse(this.user)?.jwt.jwt,
							JSON.parse(this.user)?.jwt.expiry_date
						),
						JSON.parse(this.user)?.first_name,
						JSON.parse(this.user)?.last_name,
						JSON.parse(this.user)?.email,
						this.profileImage != 'No image found' ? this.profileImage : null
					);
					/** *Save user info into local storage */
					localStorage.setItem('user', JSON.stringify(user_val));

					/** *Mark for check */
					this._changeDetectorRef.markForCheck();
				}
			});

		this.router.events.subscribe((e) => {
			if (e instanceof NavigationEnd) {
				if (e.url.includes('/fundraising') || e.url.includes('/donate')) {
					this.fundraiserService
						.getCurrentFundraiser()
						.subscribe((fundraiser) => {
							if (fundraiser != null && fundraiser != undefined) {
								if (fundraiser?.profile?.custom_logo) {
									this.logo = fundraiser?.['profile']?.['custom_logo'];
								}
							}
						});
				} else {
					this.setLogo(window.innerWidth);
				}
			}
		});
		if (this._router.url.includes('organisation')) {
			this.isPersonalFundraising = false;
			this.isOrganisation = true;
		}

		if (this.isCustomDomain(this.extractDomainFromUrl(window.location.href))) {
			this.isCustomDomainActive = true;
		}
	}

	ngAfterViewInit() {
		this.customDomainService.getIsCustomDomain().subscribe((res: any) => {
			this.isCustomDomainActive = res;
		});
	}

	menuOpened(): void {
		this.activeItem = 'explore';
	}

	menuClosed(): void {
		this.activeItem = '';
	}

	mobileMenuOpened(): void {
		this.mobileActiveItem = 'mobilemenu';
	}

	mobileMenuClosed(): void {
		this.mobileActiveItem = '';
	}

	getActiveItem() {
		this.router.events.subscribe((e) => {
			if (e instanceof NavigationEnd) {
				if (e.url.includes('/organisation')) {
					this.activeItem = 'organisation';
				} else if (e.url.includes('/search')) {
					this.activeItem = 'search';
				} else if (e.url.includes('/login')) {
					this.activeItem = 'login';
				} else if (e.url.includes('/account')) {
					this.activeItem = 'login';
				} else if (e.url === '/') {
					this.activeItem = 'individuals';
				} else {
					this.activeItem = '';
				}
			}
		});
	}

	/**
	 * Function to navigate to personal fundraising.
	 */
	routeToPersonalFundraising() {
		this.activeItem = 'individuals';
		this._router.navigate(['']);
	}
	/**
	 * Function to navigate to organisation fundraising.
	 */
	routeToOrganisation() {
		this.activeItem = 'organisation';
		this._router.navigate(['organisation']);
	}

	/**
	 * On destroy
	 */
	ngOnDestroy(): void {
		/** *Unsubscribe from all subscriptions */
		this._unsubscribeAll.complete();
	}
	/*
	 * Function for user menu clicks
	 * @param value
	 */
	userMenuClick(value: string) {
		switch (value.toLowerCase()) {
			case 'myaccount':
				this.router.navigate(['/profile']);
				break;

			case 'helpcenter':
				window.location.href =
					'https://helpdesk' +
					'.whydonate.com' +
					'/' +
					this.currentLanguageCode;
				break;

			case 'logout':
				this.accountService.logout();
				break;
		}
	}

	/*
	 * Function to retrieve login info
	 */
	getLoggedInInfo() {
		this.accountService.getLoginInformation().subscribe((data: Boolean) => {
			if (data == true) {
				this.isLoggedIn = true;
				this.user = localStorage.getItem('user');
				this.profileImage = JSON.parse(this.user)?.profile_image;
				if (
					this.profileImage == null ||
					this.profileImage.includes(
						'https://res.cloudinary.com/whydonate/image/upload/v1/'
					)
				) {
					this.profileImage = this.defaultProfileImage;
				} else {
					this.profileImage;
				}
			} else {
				this.isLoggedIn = false;
			}
		});
	}

	/*
	 * Route to login
	 */
	routeToLogin() {
		// SET PREVIOUS PATH TO EMPTY BECAUSE LOGIN IS HAPPENING ON USER CLICK
		this.activeItem = 'login';
		localStorage.setItem('previous_path', '');
		this.router.navigate(['account']);
	}

	/*
	 * Route to search
	 */
	routeToSearch() {
		this.activeItem = 'search';
		this.router.navigate(['search']);
	}

	/*
	 * Route to home
	 */
	routeToHome() {
		this.router.navigate(['/']);
	}
	/*
	 * Route to custom branding
	 */
	routeToBranding() {
		let navigationExtras: NavigationExtras = { fragment: 'branding' };
		this.router.navigate(['custom-branding'], navigationExtras);
	}
	/*
	 * Route to custom email
	 */
	routeToEmail() {
		this.router.navigate(['custom-email']);
	}

	routeToReceipt() {
		this.router.navigate(['custom-receipt']);
	}

	startFundraiser(): void {
		this.router.navigate(['/start']);
	}

	/** *Header Links Method */
	getUrl() {
		this.router.events
			.pipe(filter((event: any) => event instanceof NavigationEnd))
			.subscribe((x: any) => {
				this.currentLanguageCode = x.url;
				this.subject.next(this.currentLanguageCode);
			});
		return this.subject.asObservable();
	}

	languageForWhydonatePlatform() {
		window.location.href = 'https://whydonate.com/' + this.whydonatePlatformUrl;
	}
	languageForDonationPlugin() {
		window.location.href = 'https://whydonate.com/' + this.donationPluginUrl;
	}
	// languageForDigitalPinBox() {
	// 	window.location.href = 'https://whydonate.com/' + this.digitalPinBoxUrl;
	// }
	handleImageError(event: any) {
		event.target.src = this.defaultProfileImage;
	}

	/**
	 * Function to toggle left side navigation menu
	 */
	toggleSidenav() {
		var innerWidth = window.innerWidth;
		this.isShowText = this._sidenavService.getIsShowTextValue();
		this.isShowIcon = this._sidenavService.getIsShowIconValue();

		if (innerWidth < 600) {
			// Conditions For Mobile View
			this.isShowText = !this.isShowText;
			this.isShowIcon = !this.isShowIcon;
			this._sidenavService.toggleSidenav(this.isShowText, this.isShowIcon);
		} else {
			// Conditions For Desktop View
			this.isShowText = !this.isShowText;
			this.isShowIcon = true;
			this._sidenavService.toggleSidenav(this.isShowText, this.isShowIcon);
		}
		if (this.isShowText && this.isShowIcon) {
			this.sidenavActiveItem = 'menu';
		} else {
			this.sidenavActiveItem = '';
		}
	}

	/**
	 * Function to set default behaviour for left side navigation menu
	 */
	setSideNavDefaults() {
		var innerWidth = window.innerWidth;

		if (innerWidth < 600) {
			// Conditions For Mobile View
			this.isShowText = false;
			this.isShowIcon = false;
		} else if (innerWidth >= 600 && innerWidth < 1079) {
			// Conditions For Tablet/Laptop View
			this.isShowText = false;
			this.isShowIcon = true;
		} else {
			// Conditions For Large Desktop View
			this.isShowText = true;
			this.isShowIcon = true;
		}

		this._sidenavService.toggleSidenav(this.isShowText, this.isShowIcon);
	}

	/**
	 * Function to Set Responsive Logo in Header
	 * @param innerWidth
	 */
	async setLogo(innerWidth: number) {
		if (this.isCustomDomain(this.extractDomainFromUrl(window.location.href))) {
			try {
				// Initialize a variable to store the custom domain settings data
				await this.customDomainService
					.getCustomDomainData(this.extractDomainFromUrl(window.location.href))
					.then((res: any) => {
						let customDomainSettingsData = res?.data;
						// Extract relevant flags from the response data
						let isCustomFundraiserHomePageFlag =
							customDomainSettingsData?.is_fundraiser_home;
						let isCustomHomePageFlag = customDomainSettingsData?.is_custom_home;

						// EXTRACT DATA BASED ON CUSTOM HOME PAGE
						if (isCustomHomePageFlag) {
							this.logo =
								this.IMAGE_PREFIX +
								customDomainSettingsData?.custom_branding?.custom_logo +
								this.IMAGE_POSTFIX;
						} else if (isCustomFundraiserHomePageFlag) {
							this.logo =
								customDomainSettingsData?.fundraiser_data?.fudraiserDetails?.profile?.custom_logo;
						} else {
							this.logo =
								innerWidth < 500
									? 'https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/whydonate_icon/public'
									: 'https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/WhyDonatesSVG/public';
						}
					});
			} catch (error) {
				// Handle any errors that occur during the data retrieval process
				console.error('Error fetching custom domain data:', error);
				this.logo =
					innerWidth < 500
						? 'https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/whydonate_icon/public'
						: 'https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/WhyDonatesSVG/public';
			}
		} else if (this.isLoggedIn == true && this.accountService.checkHeaders()) {
			this._profileService
				.getProfile()
				.pipe(takeUntil(this._unsubscribeAll))
				.subscribe((userProfile) => {
					this.userProfile = userProfile;
					this._customBrandingService.setIsReceived(
						this.userProfile?.data?.profile?.is_receiver || false
					);
					try {
						if (
							this.userProfile?.data?.profile?.custom_logo != null &&
							this.userProfile?.data?.profile?.custom_logo !=
								'https://res.cloudinary.com/whydonate/image/upload/dpr_auto,f_auto,q_auto/whydonate-production/platform/visuals/whydonate-logo-licht.webp' &&
							this.userProfile?.data?.profile?.custom_logo !=
								'https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/whydonate_icon/public'
						) {
							this.logo = Tools.getCloudinaryCustomLogoPath(
								this.userProfile?.data?.profile?.custom_logo
							);
						} else {
							if (innerWidth < 500) {
								this.logo =
									'https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/whydonate_icon/public';
							} else {
								this.logo =
									'https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/WhyDonatesSVG/public';
							}
						}
					} catch (err) {
						if (innerWidth < 500) {
							this.logo =
								'https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/whydonate_icon/public';
						} else {
							this.logo =
								'https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/WhyDonatesSVG/public';
						}
					}
				});
		} else {
			if (innerWidth < 500) {
				this.logo =
					'https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/whydonate_icon/public';
			} else {
				this.logo =
					'https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/WhyDonatesSVG/public';
			}
		}
	}

	extractDomainFromUrl(url: string): string {
		let cleanedUrl = url
			.replace(/^(https?:\/\/)?(www\d?\.)?/, '')
			.replace(/\/$/, '');
		return cleanedUrl.split('/')[0];
	}

	isCustomDomain(domain: string): boolean {
		let officialDomains = environment.OFFICIAL_DOMAINS;
		return !officialDomains.includes(domain);
	}

	
	truncateText(text: string) {
		let maxLength = 26;
		if (text.length > maxLength) {
			return text.slice(0, maxLength) + '...';
		} else {
			return text;
		}
	}

	shouldShowTooltip(email: string): boolean {
		let limit = 26;
		return email.length > limit;
	}
}
